import { api as baseApi } from '@services/apiService';
import { ENV } from '@utils/env';

export function api(app: string) {
  return baseApi.extend({
    prefixUrl: ENV.apiUrls.public,
    credentials: 'omit',
    headers: {
      'x-evervault-app-id': app,
    },
  });
}

export { directApi } from '@services/apiService';
